module.exports = __webpack_public_path__ + "img/tap.c22ad92b.svg";